import { getCountries } from './client';

export const doGetCountries: Function = () => async (dispatch: Function, getState: Function) => {
    const { isLoading, countries } = getState().countries;

    if (isLoading || countries.list.length) {
        return;
    }

    dispatch({ type: 'GET_COUNTRIES_REQUEST' });
    try {
        const payload = await getCountries();

        dispatch({ type: 'GET_COUNTRIES_SUCCESS', payload: payload });
    } catch (e: any) {
        dispatch({ type: 'GET_COUNTRIES_ERROR', error: e?.response?.data });
    }
};
